import {createContext, useEffect, useState} from "react";
import axios from "axios";

export const AppContext = createContext({ apiUrl: "", functionCode: "", contactUsEmailAddress: "" });

export const useApplicationConfiguration = () => {
    const [configuration, setConfiguration] = useState({apiUrl: "", functionCode: "", contactUsEmailAddress: ""});

    useEffect(() => {
        async function fetchData () {
            const request = `/api/configuration`
            const result = await axios(request);
            
            setConfiguration({
                apiUrl: result.data.invitationApiUrl,
                functionCode: result.data.functionCode,
                contactUsEmailAddress: result.data.contactUsEmailAddress
            });
        }

        fetchData();
    }, []);
    
    return configuration;
};